import TableInvoices from 'invoices/components/TableInvoices';
import addInvoiceUseCase from 'invoices/services/addInvoiceUseCase';
import deleteInvoiceUseCase from 'invoices/services/deleteInvoiceUseCase';
import { getInvoices } from 'invoices/services/store/actions';
import { getInvoicesData } from 'invoices/services/store/reducers';
import updateInvoiceUseCase from 'invoices/services/updateInvoiceUseCase';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import InvoiceDetailContainer from './InvoiceDetailContainer';
import findInvoiceDetailByIdUseCase from 'invoices/services/detail/findInvoiceDetailByIdUseCase';
import { getStock, getTasks } from 'actions';
import createPDFInvoiceUseCase from 'invoices/services/createPDFInvoice';
import { columnsInvoice } from 'invoices/services/config';
import SearchField from 'invoices/components/SearchField';
import { getClients } from 'clients/services/actions';
import { getClientsData } from 'clients/services/reducers';
import { getTasksData } from 'common/store/reducers/tasks';
import filterItemsUseCase from 'invoices/services/filterItemsUseCase';
import CheckPaid from 'tasks/components/CheckPaid';
import sendInvoiceByEmailUseCase from 'invoices/services/sendInvoiceByEmailUseCase';
import { Button, Checkbox } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import exportInvoicesExcelUseCase from 'invoices/services/exportInvoicesExcelUseCase';
import SelectField from 'common/components/SelectField';
import findInvoiceByIdUseCase from 'invoices/services/findInvoiceByIdUseCase';
import { history } from 'common/services/history';
import { makeZebraRowStyle } from 'common/services/zebraRowStyle';
import updateTaskUseCase from 'tasks/services/updateTaskUseCase';
import SearcherPro from 'stock/components/SearcherPro';
import { filterInvoicesDataByText } from 'invoices/services/config/filterInvoiceData';
import createInvoiceRecurrent from 'invoices/services/createInvoiceRecurrent';
import duplicateInvoiceUseCase from 'invoices/services/duplicateInvoiceUseCase';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@material-ui/core';
import InvoiceSummaryPopup from 'invoices/components/InvoiceSummaryPopup';

class InvoicesContainer extends Component {
    constructor(props) {
        super(props)
        this.tableRef = React.createRef()
        this.state = {
            openDetail: false,
            dataInvoice: {},
            dataDetail: {},
            loadingColumns: false,
            tasksSelected: [],
            selectAll: false,
            searchData: { text: "" },
            openDialogDuplicateTask: null,
            resultDialog: { open: false, message: '', success: true },
        }
    }

    handleSearchText = (text) => {
        this.setState({ searchData: { text }, tasksSelected: [], selectAll: false });
    }

    handleTaskDelete = async (task) => {
        const tasks = this.state.tasksSelected.length > 0 ? this.state.tasksSelected : [task]

        for (let i = 0; i < tasks.length; i++) {
            await deleteInvoiceUseCase(tasks[i])
        }

        this.clearSelected()
        return true
    }

    handleInvoicePrint = (rowData, operation) => {
        const tasks = this.state.tasksSelected.length > 0 ? this.state.tasksSelected : [rowData]

        const isProforma = window.location.search.split("isProforma=")[1]
        tasks.forEach(task => {
            createPDFInvoiceUseCase({ invoiceData: task, operation, isProforma })
        })

        this.clearSelected()
    }

    clearSelected = () => {
        this.setState({ ...this.state, tasksSelected: [], selectAll: false })
    }

    handleOpenDetail = async (invoiceData) => {
        try {
            const data = await findInvoiceDetailByIdUseCase(invoiceData.id)
            this.setState({
                openDetail: true,
                dataInvoice: invoiceData,
                dataDetail: { items: data.data || [] }
            })
        } catch (e) {
            console.error('Error abriendo detalle de factura/proforma:', e)
            alert('Error al abrir el detalle. Comprueba la consola.')
        }
    }

    handleInvoicesExport = data => {
        exportInvoicesExcelUseCase(data, this.props.clients)
    }

    handleChangePaymentMode = (oldTask, newPaymentMode, fromDetails) => {
        const newTask = { ...oldTask, paymentMode: newPaymentMode }
        if (fromDetails) {
            this.setState({ ...this.state, dataInvoice: newTask })
        }
        return updateInvoiceUseCase(newTask, oldTask)
    }

    handleChangeTypeCreation = (oldTask, typeCreation) => {
        const newTask = { ...oldTask, typeCreation: Number(typeCreation) }
        return updateInvoiceUseCase(newTask, oldTask)
    }

    handleConvertInInvoice = async (oldInvoice) => {
        let refs = new Set();
        try {
            const detail = await findInvoiceDetailByIdUseCase(oldInvoice.id);
            if (detail?.data?.length) {
                detail.data.forEach(item => {
                    const ref = (item?.reference || "").toString().trim();
                    if (ref) refs.add(ref);
                });
            }
        } catch (e) {
            console.warn("No se pudieron cargar detalles de la proforma", e);
        }

        if (oldInvoice?.taskReference) {
            refs.add(oldInvoice.taskReference.toString().trim());
        }

        try {
            const allTasks = getTasksData(this.props.tasks);
            const toUpdate = allTasks.filter(t => refs.has((t.reference || "").toString().trim()));

            for (const task of toUpdate) {
                const needsUpdate = Number(task.payed) !== 1 || Number(task.invoiced) !== 1;
                if (needsUpdate) {
                    const updated = { ...task, payed: 1, invoiced: 1 };
                    await updateTaskUseCase(updated, task);
                }
            }
        } catch (e) {
            console.error("Error actualizando tareas al convertir proforma:", e);
        }

        await duplicateInvoiceUseCase(oldInvoice.id, true);
        history.push("/invoices");
    }

    handleCheckedSelected = (task, flag) => {
        if (flag) {
            this.setState(prev => ({
                ...prev,
                tasksSelected: [...prev.tasksSelected, task]
            }));
            return;
        }

        this.setState(prev => ({
            ...prev,
            tasksSelected: prev.tasksSelected.filter(
                t => t.numInvoice !== task.numInvoice
            )
        }));
    }

    handleSelectAll = flag => {
        if (flag) {
            const tasksSelected = this.tableRef.current.dataManager.searchedData
            this.setState({ ...this.state, tasksSelected, selectAll: flag })
            return
        }

        this.setState({ ...this.state, tasksSelected: [], selectAll: flag })
    }

    handleDuplicateInvoice = async () => {
        try {
            await duplicateInvoiceUseCase(this.state.openDialogDuplicateInvoice)
            this.setState({
                openDialogDuplicateInvoice: null,
                resultDialog: { open: true, message: 'Duplicada con éxito', success: true }
            })
        } catch (e) {
            console.error(e)
            this.setState({
                openDialogDuplicateInvoice: null,
                resultDialog: { open: true, message: 'Error al duplicar', success: false }
            })
        }
    }

    handleOpenDialogDuplicateInvoice = (invoice) => {
        this.setState({ openDialogDuplicateInvoice: invoice.id })
    }

    handleSendInvoiceEmail = async (invoice) => {
        try {
            const isProforma = window.location.search.split("isProforma=")[1] === "true";
            const detail = await findInvoiceDetailByIdUseCase(invoice.id);

            await sendInvoiceByEmailUseCase({
                invoiceData: invoice,
                invoiceDetail: detail.data,
                isProforma
            });

            alert(isProforma ? "Proforma enviada por email ✅" : "Factura enviada por email ✅");

        } catch (err) {
            alert(err.message || "Error enviando factura por email");
            console.error(err);
        }
    };

    async componentDidMount() {
        const { invoices, getInvoices,
            stockList, getStock,
            clients, getClients,
            tasks, getTasks } = this.props

        this.setState({ ...this.state, loadingColumns: true })

        createInvoiceRecurrent()

        const searchClients = (rowData, onRowDataChange) => {
            const clientsToSearch = getClientsData(this.props.clients).sort((c1, c2) => c2.lastUpdated - c1.lastUpdated)

            return (
                <SearchField
                    textInitial={rowData.nameClient}
                    onTextRender={item => item.name}
                    items={clientsToSearch}
                    onFilterItems={(itemList, textFilter) =>
                        filterItemsUseCase({
                            itemList,
                            textFilter,
                            fieldsFilter: ["name", "id"]
                        })
                    }
                    onSelectItem={item => {
                        rowData.nameClient = item.name
                        rowData.dniClient = item.id
                        if (item.defaultPaymentMode !== undefined && item.defaultPaymentMode !== "" && item.defaultPaymentMode !== null) {
                            rowData.paymentMode = Number(item.defaultPaymentMode)
                        }
                        if (onRowDataChange) onRowDataChange({ ...rowData })
                    }}
                    onRenderItem={(item) => item.id + " " + item.name}
                />
            )
        }


        const searchTasks = (rowData, onRowDataChange) => {
            const tasksToSearch = getTasksData(this.props.tasks).sort(((t1, t2) => t2.dateEntry - t1.dateEntry))

            return (
                <SearchField
                    textInitial={rowData.taskReference}
                    onTextRender={item => item.reference}
                    items={tasksToSearch}
                    onFilterItems={(itemList, textFilter) =>
                        filterItemsUseCase({
                            itemList,
                            textFilter,
                            fieldsFilter: ["reference", "description"]
                        })
                    }
                    onSelectItem={item => {
                        rowData.taskReference = item.reference
                        rowData.newTask = true
                        if (item.dni && !rowData.dniClient) {
                            rowData.dniClient = item.dni
                            rowData.nameClient = item.clientName || rowData.nameClient || ''
                        }
                        if (onRowDataChange) onRowDataChange({ ...rowData })
                    }}
                    onRenderItem={item => item.reference + " " + item.description}
                />
            )
        }

        const checkPaid = rowData => {

            if (!rowData) return null

            return (
                <CheckPaid
                    //Añadimos key al componente CheckPaid para forzar el re-render cuando cambia el estado de pago evitando asi recargar toda la página
                    key={`${rowData.id}-${rowData.payed}`}
                    props={rowData}
                    handleChangePaid={(rowData, payedFlag) => {
                        const oldInvoice = { ...rowData }
                        rowData.payed = payedFlag
                        updateInvoiceUseCase(rowData, oldInvoice, true)
                    }}
                    field="payed"
                />
            )
        }

        const reference = props => {
            return (
                <Button variant="outlined"
                    style={{ width: '100%', color: 'black', fontWeight: 'bold', border: '2px solid black' }}
                    onClick={() => this.handleOpenDetail(props)}>
                    {props ? props.numInvoice : ""}
                </Button>
            )
        }

        const selectPaymentMode = ({ rowData, mapPaymentMode, value }) => {
            return (
                <SelectField
                    mapData={mapPaymentMode}
                    value={value}
                    handleChangeValue={value => this.handleChangePaymentMode(rowData, value)}
                />
            )
        }

        const selectTypeCreation = ({ rowData, mapTypeCreation, value, disabled }) => {
            return (
                <SelectField
                    mapData={mapTypeCreation}
                    value={value}
                    handleChangeValue={value => this.handleChangeTypeCreation(rowData, value)}
                    disabled={disabled}
                />
            )
        }

        const checkedSelected = (props) => {
            if (!props) {
                return
            }

            return (
                <CheckPaid props={props}
                    field="selected"
                    handleChangePaid={this.handleCheckedSelected}
                    deselect={!this.state.tasksSelected.length}
                    select={this.state.tasksSelected.some(task => task.numInvoice === props.numInvoice)}
                />
            )
        }

        const checkAll = () => {
            return (
                <Checkbox checked={this.state.selectAll} onChange={e => this.handleSelectAll(e.target.checked)} />
            )
        }

        const paymentModeEditComponent = ({ value, onChange, rowData }) => {
            const effectiveValue = rowData.paymentMode !== undefined ? rowData.paymentMode : (value ?? 1)
            return (
                <SelectField
                    mapData={{ 0: 'Efectivo', 1: 'Tarjeta', 2: 'Transferencia' }}
                    value={effectiveValue}
                    handleChangeValue={v => {
                        const n = Number(v)
                        rowData.paymentMode = n
                        rowData._paymentModeManuallySet = true
                        onChange(n)
                    }}
                />
            )
        }

        const isProforma = window.location.search.split("isProforma=")[1]
        this.columns = columnsInvoice({ checkAll, checkedSelected, reference, searchClients, searchTasks, checkPaid, selectPaymentMode, paymentModeEditComponent, selectTypeCreation, isProforma })
        this.setState({ ...this.state, loadingColumns: false })

        let idToOpen = window.location.search.split("id=")[1]
        if (idToOpen) {
            idToOpen = idToOpen.split("&")[0]
            const allInvoices = getInvoicesData(invoices)
            const isAlreadyInStore = allInvoices.some(inv => inv.id === idToOpen)
            const typeFilter = isProforma
                ? inv => inv.type === 'Proforma'
                : inv => inv.type !== 'Proforma' && inv.type !== 'Canje'
            const filteredCount = allInvoices.filter(typeFilter).length
            const numInvoice = isAlreadyInStore ? filteredCount : filteredCount + 1
            findInvoiceByIdUseCase({ id: idToOpen })
                .then(task => this.handleOpenDetail({ ...task, numInvoice, id: idToOpen }))
                .catch(e => {
                    alert("Ha ocurrido un error")
                    console.error(e)
                })
        }

        if (clients.length === 0) {
            getClients()
        }

        if (invoices.length === 0) {
            getInvoices()
        }
        if (stockList.length === 0) {
            getStock()
        }
        if (tasks.length === 0) {
            getTasks();
        }
    }

    getInvoicesData = invoices => {
        const isProforma = window.location.search.split("isProforma=")[1]
        const allInvoicesData = getInvoicesData(invoices)
            .filter(invoice => isProforma ? invoice.type === "Proforma" : invoice.type !== "Proforma");

        const sortByDate = (a, b) => {
            const aD = a.invoiceDate || Number.MAX_SAFE_INTEGER;
            const bD = b.invoiceDate || Number.MAX_SAFE_INTEGER;
            return bD - aD;
        };

        const canjeInvoices = allInvoicesData.filter(inv => inv.type === "Canje");
        const regularInvoices = allInvoicesData.filter(inv => inv.type !== "Canje");

        const sortedCanje = [...canjeInvoices].sort(sortByDate);
        const sortedRegular = [...regularInvoices].sort(sortByDate);

        const numberedCanje = sortedCanje.map((invoice, index, arr) => {
            const numInvoice = `C${arr.length - index}`;
            const buscador = [
                invoice.concept || '',
                invoice.nameClient || '',
                invoice.dniClient || '',
                numInvoice,
                invoice.taskReference || '',
            ].join(' ');
            return { ...invoice, numInvoice, buscador };
        });

        const numberedRegular = sortedRegular.map((invoice, index, arr) => {
            const numInvoice = arr.length - index;
            const buscador = [
                invoice.concept || '',
                invoice.nameClient || '',
                invoice.dniClient || '',
                String(numInvoice),
                invoice.taskReference || '',
            ].join(' ');
            const indexPrincipal = invoice.invoicePrincipalId ? sortedRegular.findIndex(inv => inv.id === invoice.invoicePrincipalId) : -1;
            return {
                ...invoice,
                numInvoice,
                buscador,
                invoicePrincipalCode: indexPrincipal !== -1 ? arr.length - indexPrincipal : ""
            };
        });

        const ordered = [...numberedCanje, ...numberedRegular].sort(sortByDate);
        return filterInvoicesDataByText(ordered, this.state.searchData.text);
    }

    render() {
        const { openDetail, dataInvoice, dataDetail, tasksSelected } = this.state
        const { invoices } = this.props
        const isProforma = window.location.search.split("isProforma=")[1]

        // Fila zebra + hover + color de selección
        const getRowStyle = makeZebraRowStyle({
            selectedIds: tasksSelected.map(t => t.numInvoice),
            getRowKey: row => row.numInvoice,     // clave de fila en Invoices
        });

        let comSelect;

        if (tasksSelected.length > 0 && tasksSelected.length < 10) {
            comSelect =
                <div style={{ display: 'flex', height: '40px', alignItems: 'center', backgroundColor: 'rgb(253, 224, 234)', color: 'red', paddingLeft: '10px', fontSize: '1.2rem', borderTopRightRadius: '4px', borderTopLeftRadius: '4px' }}>
                    <span><span style={{ fontWeight: 'bold' }}>TAREAS:</span> {this.state.tasksSelected.map(task => task.numInvoice).join(', ')}</span>
                </div>
        } else if (tasksSelected.length >= 10) {
            comSelect =
                <div style={{ display: 'flex', height: '40px', alignItems: 'center', backgroundColor: 'rgb(253, 224, 234)', color: 'red', paddingLeft: '10px', fontSize: '1.2rem', borderTopRightRadius: '4px', borderTopLeftRadius: '4px' }}>
                    <span><span style={{ fontWeight: 'bold' }}>TAREAS SELECCIONADAS:</span> {this.state.tasksSelected.length}</span>
                </div>
        }

        return (
            <div style={{ padding: '20px 20px 20px 20px' }}>
                <SearcherPro
                    textSearch={this.state.searchData.text}
                    handleChangeTextSearch={this.handleSearchText}
                />
                {comSelect}
                {!this.state.loadingColumns && <TableInvoices
                    tableRef={this.tableRef}
                    columns={this.columns}
                    data={this.getInvoicesData(invoices)}
                    onFilterChange={() => this.forceUpdate()}
                    onInvoiceAdd={invoice => {
                        if (!invoice._paymentModeManuallySet && invoice.dniClient) {
                            const client = getClientsData(this.props.clients).find(c => c.id === invoice.dniClient)
                            if (client?.defaultPaymentMode !== undefined && client?.defaultPaymentMode !== "" && client?.defaultPaymentMode !== null) {
                                invoice.paymentMode = Number(client.defaultPaymentMode)
                            }
                        }
                        delete invoice._paymentModeManuallySet
                        return addInvoiceUseCase(invoice, isProforma)
                    }}
                    onInvoiceUpdate={updateInvoiceUseCase}
                    onInvoiceDelete={this.handleTaskDelete}
                    onInvoicePrint={this.handleInvoicePrint}
                    onInvoicesExport={this.handleInvoicesExport}
                    onDuplicateInvoice={this.handleOpenDialogDuplicateInvoice}
                    onConvertInInvoice={this.handleConvertInInvoice}
                    onSendInvoiceEmail={this.handleSendInvoiceEmail}
                    isProforma={isProforma}
                    tableRefProp={this.tableRef}
                    getRowStyle={getRowStyle}
                />}
                {openDetail && <InvoiceDetailContainer
                    dataInvoice={dataInvoice}
                    dataDetail={dataDetail}
                    open={openDetail}
                    onClose={() => this.setState({ ...this.state, openDetail: false })}
                    isProforma={isProforma}
                    onChangePaymentMode={(data, value) => this.handleChangePaymentMode(data, value, true)}
                />}
                <Dialog open={!!this.state.openDialogDuplicateInvoice}>
                    <DialogTitle>Duplicar elemento</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            ¿Quieres duplicar este elemento? Esta acción creará una copia de la factura/proforma con los mismos datos.
                        </DialogContentText>
                        <DialogActions>
                            <Button onClick={() => this.setState({ openDialogDuplicateInvoice: false })}>
                                Cancelar
                            </Button>
                            <Button onClick={() => this.handleDuplicateInvoice()} variant='contained' color='primary'>
                                Duplicar
                            </Button>
                        </DialogActions>
                    </DialogContent>
                </Dialog>
                <Dialog open={!!this.state.resultDialog.open} onClose={() => this.setState({ resultDialog: { ...this.state.resultDialog, open: false } })} maxWidth="xs" fullWidth>
                    <DialogTitle disableTypography style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, paddingBottom: 8, paddingTop: 24 }}>
                        {this.state.resultDialog.success
                            ? <CheckCircleIcon style={{ color: '#43a047', fontSize: 32 }} />
                            : <ErrorIcon style={{ color: '#e53935', fontSize: 32 }} />
                        }
                        <span style={{ fontSize: '1.1rem', fontWeight: 600 }}>
                            {this.state.resultDialog.success ? 'Duplicada con éxito' : 'Error'}
                        </span>
                    </DialogTitle>
                    <DialogActions style={{ justifyContent: 'center', paddingBottom: 16 }}>
                        <Button onClick={() => this.setState({ resultDialog: { ...this.state.resultDialog, open: false } })} color="primary" variant="contained" disableElevation>
                            Aceptar
                        </Button>
                    </DialogActions>
                </Dialog>
                <InvoiceSummaryPopup
                    tableRef={this.tableRef}
                    data={this.getInvoicesData(invoices)}
                    tasksSelected={tasksSelected}
                />
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => ({
    getInvoices: payload => dispatch(getInvoices(payload)),
    getStock: payload => dispatch(getStock(payload)),
    getClients: payload => dispatch(getClients(payload)),
    getTasks: payload => dispatch(getTasks(payload))
})

const mapStateToProps = state => ({
    invoices: state.invoices.data,
    stockList: state.stock.data,
    clients: state.clients.data,
    tasks: state.tasks.data
})

export default connect(mapStateToProps, mapDispatchToProps)(InvoicesContainer);
